import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TutorialService {
  private tutorialState = {};
  constructor() {
    let v = localStorage.getItem("tutorial_keepout");
    if (!v) {
      this.tutorialState = {};
    } else {
      this.tutorialState = JSON.parse(v);
    }
  }

  public setPagePassed(page: string) {
    this.tutorialState[page] = true;
    localStorage.setItem("tutorial_keepout", JSON.stringify(this.tutorialState));
  }

  public getTutorialPassed(page: string): boolean {
    return this.tutorialState[page];
  }
}
